export const activityGroups = [
  {
    title: "인천 대공원 연합 봉사",
    images: [
      "https://static.wixstatic.com/media/17b604_b855e28fcd2e4aebbe932ca110333664~mv2.png",
      "https://static.wixstatic.com/media/17b604_7c774d44614d42e6a2b0379619aa700a~mv2.png",
      "https://static.wixstatic.com/media/17b604_be8f8591017047ce991d015adf24dbde~mv2.jpg",
    ],
  },
  {
    title: "마음톡톡콘서트",
    images: [
      "https://static.wixstatic.com/media/17b604_f8f1a01e134149e887aa18b84e17eafa~mv2.jpg",
      "https://static.wixstatic.com/media/17b604_8fcf0468ac0e4d04953b13c70f63869a~mv2.jpg",
    ],
  },
  {
    title: "이제는 행복할 차례, 음악 토크 콘서트",
    images: [
      "https://static.wixstatic.com/media/17b604_056c6c9008ec43dd81ede69a7c262c70~mv2.jpg",
      "https://static.wixstatic.com/media/17b604_5b2af510c55646e498e8ce21d0e98688~mv2.jpg",
    ],
  },
  {
    title: "남동구청 소래찬 김장 한마당",
    images: [
      "https://static.wixstatic.com/media/17b604_16f81f9063b84f929ee8c5bc9c6c9ef4~mv2.jpg",
      "https://static.wixstatic.com/media/17b604_3f2b59e2141b4e71969d5634031c7ba5~mv2.png",
      "https://static.wixstatic.com/media/17b604_c1bf62872f0e46178e471acf0581fd0c~mv2.png",
    ],
  },
];